import { InternalLink } from '../types/InternalLink';
import { Link } from '../types/Link';

export const isInternalLink = (link: Link): link is InternalLink => {
  return link.kind === 'internal';
};
